module.exports = __webpack_public_path__ + "static/media/validation.b3505e77.png";